<template>
  <textarea
    ref="textarea"
    :value="modelValue"
    rows="4"
    class="block w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500
      focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white
      dark:focus:ring-blue-500 dark:focus:border-blue-500"
    :class="[INPUT_SIZES[size]]"
    @input="onInput" />
</template>

<script setup>
import { ref } from 'vue'

const INPUT_SIZES = {
  default: 'px-3 py-2 text-base',
  lg: 'px-3 py-4 text-lg',
  sm: 'px-3 py-1.5 text-sm'
}

defineProps({
  modelValue: {
    required: true,
    validator: (prop) => typeof prop === 'string' || prop === null
  },
  size: {
    type: String,
    required: false,
    default: 'default',
    validator: (prop) => ['default', 'lg', 'sm'].includes(prop)
  }
})

const emits = defineEmits(['update:modelValue'])
const textarea = ref(null)
const onInput = (event) => {
  if (textarea.value) {
    textarea.value.style.height = 'auto'
    textarea.value.style.height = `${textarea.value.scrollHeight + 2}px`
  }
  emits('update:modelValue', event.target.value)
}
</script>
